export interface PlaceResult {
  place_id: string;
  addressComponents?: Array<{
    longText: string;
    shortText: string;
    types: string[];
  }>;
  location?: { lat: () => number; lng: () => number };
}

export enum GoogleAddressFields {
  StreetNumber = 'street_number',
  Route = 'route',
  Locality = 'locality',
  Sublocality = 'sublocality',
  PostalTown = 'postal_town',
  Political = 'political',
  AdministrativeAreaLevel1 = 'administrative_area_level_1',
  Country = 'country',
  PostalCode = 'postal_code',
}

export const GoogleAddressTypes: Record<string, KnownKeys> = {
  [GoogleAddressFields.StreetNumber]: 'shortText',
  [GoogleAddressFields.Route]: 'shortText',
  [GoogleAddressFields.Locality]: 'longText',
  [GoogleAddressFields.Sublocality]: 'longText',
  [GoogleAddressFields.PostalTown]: 'longText',
  [GoogleAddressFields.Political]: 'longText',
  [GoogleAddressFields.AdministrativeAreaLevel1]: 'shortText',
  [GoogleAddressFields.Country]: 'longText',
  [GoogleAddressFields.PostalCode]: 'shortText',
};

export interface GoogleAddress {
  [key: string]: any;
  AddressLine1: string;
  AddressLine2: string;
  City: string;
  StateProvince: string;
  Country: string;
  ZipCode: string;
  Latitude: number | null;
  Longitude: number | null;
}

interface GeocoderAddressComponent {
  shortText?: string;
  longText?: string;
}

type KnownKeys = keyof GeocoderAddressComponent;
